export default __webpack_public_path__ + "images/pin_b5dc51.svg";